module.exports = __webpack_public_path__ + "static/media/emoji_events-24px.2d0719fa.svg";